import React, { Component } from 'react';

import '../stylesheets/footer.css';

class Footer extends Component {
    render(){
        return(
            <footer className='fixed-bottom'>
                <div className='container-fluid'>
                <div className='row'>
                <div className='col'>
                    <a 
                    className="navbar-brand"  
                    href="http://sohammondal.com" 
                    style={{margin:'5px',
                    fontSize:'1.5em'}}
                    rel='noopener noreferrer'
                    target="_blank"><div className='logo'>Soham</div></a>
                </div>
                <div className='col'>
                <div className="social-box">

                    <a 
                    href="https://github.com/sohammondal/" 
                    rel='noopener noreferrer'
                    target="_blank"><i className="fab fa-github"></i></a>

                    <a 
                    rel='noopener noreferrer'
                    href="https://www.linkedin.com/in/soham-sm-mondal/"
                    target="_blank"><i className="fab fa-linkedin"></i></a>

                    <a 
                    rel='noopener noreferrer'
                    href="https://www.facebook.com/soham.pf.mondal"
                    target="_blank"><i className="fab fa-facebook "></i></a>
                    <a 
                    rel='noopener noreferrer' 
                    href="https://twitter.com/soham_sm_mondal"
                    target="_blank"><i className="fab fa-twitter " ></i></a>
                
                    <a 
                    href="https://www.instagram.com/soham.sm.mondal/" 
                    rel='noopener noreferrer'
                    target="_blank"><i className="fab fa-instagram"></i></a>

                </div>
                </div>
             
                </div>
                
                <div className="copyright">
                    <p>© 2018 Soham Mondal</p>
                </div>
                </div>
            </footer>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.jsx